export enum TeacherType {
  NATIVE = 'NATIVE',
  BILINGUAL = 'BILINGUAL',
}



// WEBPACK FOOTER //
// ./ts/app/shared/types/teacher-type.ts